import {
  UilSimCard,
  UilLayerGroup,
  UilUsersAlt,
  UilHdd,
  UilCodeBranch,
  UilHistory,
  UilListUl,
  UilHome,
  UilKeySkeleton,
  UilEnvelope,
  UilUserPlus,
} from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import Cookies from 'js-cookie';
import { NavTitle } from './Style';

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();
  const user = JSON.parse(Cookies.get('user'));
  /** Platform yöneticisi: API type `"super"` veya sayısal `1` olabilir */
  const isAdmin = user?.type === 'super' || user?.type === 1 || user?.type === '1';
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => ({
    topMenu: state.ChangeLayoutMode.topMenu,
  }));

  const path = '/';
  const pathName = window.location.pathname;
  const pathArray = pathName && pathName !== '/' ? pathName.split(path) : [];
  const [, firstSegment, secondSegment] = pathArray;
  const mainPath = pathArray.length > 1 ? firstSegment : '';
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  // Determine the selected key (/settings/mail → mail-settings)
  let selectedKey = `${
    mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
  }`;
  if (pathArray.length > 2 && firstSegment === 'settings' && secondSegment === 'mail') {
    selectedKey = 'mail-settings';
  }
  if (pathArray.length > 2 && firstSegment === 'admin') {
    selectedKey = secondSegment;
  }

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };
  // console.log(user);
  const items = [
    getItem(
      !topMenu && <NavTitle className="ninjadash-sidebar-nav-title">{t('application')}</NavTitle>,
      'app-title',
      null,
      null,
      'group',
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to="/">
        {t('dashboard')}
      </NavLink>,
      'dashboard',
      !topMenu && (
        <NavLink className="menuItem-iocn" to="/">
          <UilHome />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to="/organizations">
        {t('organizations')}
      </NavLink>,
      'organizations',
      !topMenu && (
        <NavLink className="menuItem-iocn" to="/organizations">
          <UilSimCard />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to="/devices">
        {t('devices')}
      </NavLink>,
      'devices',
      !topMenu && (
        <NavLink className="menuItem-iocn" to="/devices">
          <UilHdd />
        </NavLink>
      ),
    ),

    getItem(
      !topMenu && isAdmin && <NavTitle className="ninjadash-sidebar-nav-title">{t('admin')}</NavTitle>,
      'admin-title',
      null,
      null,
      'group',
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/roles">
          {t('roles')}
        </NavLink>
      ),
      'roles',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/roles">
          <UilLayerGroup />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/users">
          {t('users')}
        </NavLink>
      ),
      'users',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/users">
          <UilUsersAlt />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/firmwares">
          {t('firmwares')}
        </NavLink>
      ),
      'firmwares',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/firmwares">
          <UilCodeBranch />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/action-logs">
          {t('action-logs')}
        </NavLink>
      ),
      'action-logs',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/action-logs">
          <UilHistory />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/device-queue-logs">
          {t('device-queue-logs')}
        </NavLink>
      ),
      'device-queue-logs',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/device-queue-logs">
          <UilListUl />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/licence-activities">
          {t('licence-activities')}
        </NavLink>
      ),
      'licence-activities',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/licence-activities">
          <UilKeySkeleton />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/admin/invites">
          {t('invite-list')}
        </NavLink>
      ),
      'invites',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/admin/invites">
          <UilUserPlus />
        </NavLink>
      ),
    ),
    getItem(
      isAdmin && (
        <NavLink onClick={toggleCollapsed} to="/settings/mail">
          {t('mail-settings-menu')}
        </NavLink>
      ),
      'mail-settings',
      !topMenu && isAdmin && (
        <NavLink className="menuItem-iocn" to="/settings/mail">
          <UilEnvelope />
        </NavLink>
      ),
    ),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      selectedKeys={[selectedKey]} // Set selectedKeys based on current path
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
